import { GUIControllerBase } from "./controllers/GUIControllerBase";
import { IApp } from "./IApp";
import { ChainControllerBase } from "./controllers/ChainControllerBase";
import { UDexWatcherCoreAPI } from "./api/UDexWatcherCoreAPI";


export class App implements IApp {
    public static Inst: App;
    public static get gui() { return App.Inst._guiBase; }
    public static get chain() { return App.Inst._chainBase; }
    public static get api()  { return App.Inst._api; }

    public readonly version:string = "0.0.1";
    public static API_URL:string =  "https://lpx.plusx.app/";//"https://mirror.lpx.plusx.app/"; //"http://127.0.0.1:5031";//
    public static API_PATH:string = "watcher";// "";//
    


    private readonly _instances = new Map<Function, unknown>();
    private _guiBase: GUIControllerBase; 
    private _chainBase: ChainControllerBase; 

    public get gui(){return this._guiBase;}
    public get chain(){return this._chainBase;}
    private _api: UDexWatcherCoreAPI;
    public get api(){return this._api;}

    constructor(version:string) {
        this.version = version;
        console.log(this.version);
        App.Inst=this;
          this._api = new UDexWatcherCoreAPI(App.API_URL+App.API_PATH, (e, args)=>this._apiErrorHandler(e,args));
    }

    protected async startAsync()
    {
        this._guiBase = this.getInst(GUIControllerBase);
        this._chainBase = this.getInst(ChainControllerBase);

       // this._guiBase.dialogOkShowAsync("Invitation only mainnet test. If you have not been invited, you risk losing funds as the current LPX is temporary and will be closed before the release with private inquiry to withdraw all funds.");
    }


    public getInst<T>(cls: new (...args: any[]) => T): T {
        const instance = this._instances.get(cls);
        if (!instance) throw new Error(`No instance found for ${cls.name}`);
        return instance as T;
    }

    public addInst<T>(cls: new (...args: any[]) => T, instance: T): void {
        this._instances.set(cls, instance);
    }

     private _apiErrorHandler(e:any, args:any)
    {
        if (args&&args.callback) {args.callback(e, args); return}
        if (args&&args.skip) return;
        if (e)
        {
            let code = e.code;
            if (!code) code = e.status;
            if (code)
            {
                //if (e.code==401) {this.auth.dropAuthStateAsync(); return;}
                if (code==422&&e.message) {
                    const message=JSON.parse(e.message);
                    this.gui.dialogOkShowAsync(message.message);
                }
                // if (code==403) {
                //     this.gui.dialogOkShowAsync(message.code);
                // }
            }
            if (e.actionCode)
            {
                // const failed = new ResultFail(e);
                // this.gui.popInfoAsync(failed.message);
            }
        }
        console.log(e);
    }
}
